'use client'

import React from 'react'

type Props = {
    springConstant: number
    displacement: number
}

const WIDTH = 340
const HEIGHT = 200
const PAD_LEFT = 44
const PAD_RIGHT = 12
const PAD_TOP = 14
const PAD_BOTTOM = 28
const PLOT_W = WIDTH - PAD_LEFT - PAD_RIGHT
const PLOT_H = HEIGHT - PAD_TOP - PAD_BOTTOM

export default function SpringForceChart({ springConstant, displacement }: Props) {
    const k = springConstant
    const xMax = Math.max(Math.abs(displacement) * 1.3, 0.01)
    const fAtX = (x: number) => k * x
    const fMax = Math.max(Math.abs(fAtX(xMax)), Math.abs(fAtX(-xMax)), 0.01)

    const xToSvg = (x: number) => PAD_LEFT + ((x + xMax) / (2 * xMax)) * PLOT_W
    const yToSvg = (f: number) => PAD_TOP + PLOT_H - ((f + fMax) / (2 * fMax)) * PLOT_H

    const x1 = -xMax
    const x2 = xMax
    const y1 = fAtX(x1)
    const y2 = fAtX(x2)

    const markerX = xToSvg(displacement)
    const markerY = yToSvg(fAtX(displacement))

    return (
        <svg width={WIDTH} height={HEIGHT} viewBox={`0 0 ${WIDTH} ${HEIGHT}`} style={{ maxWidth: '100%', height: 'auto' }}>
            <line x1={PAD_LEFT} y1={PAD_TOP} x2={PAD_LEFT} y2={HEIGHT - PAD_BOTTOM} stroke="#9ca3af" strokeWidth={1} />
            <line x1={PAD_LEFT} y1={yToSvg(0)} x2={WIDTH - PAD_RIGHT} y2={yToSvg(0)} stroke="#9ca3af" strokeWidth={1} />
            <text x={PAD_LEFT} y={HEIGHT - 8} fontSize={10} fill="#6b7280">Displacement x (m)</text>
            <text x={4} y={PAD_TOP + 6} fontSize={10} fill="#6b7280">Force (N)</text>
            <line x1={xToSvg(x1)} y1={yToSvg(y1)} x2={xToSvg(x2)} y2={yToSvg(y2)} stroke="#2563eb" strokeWidth={2} />
            <line x1={markerX} y1={markerY} x2={markerX} y2={yToSvg(0)} stroke="#dc2626" strokeWidth={1} strokeDasharray="3,3" opacity={0.6} />
            <circle cx={markerX} cy={markerY} r={4.5} fill="#dc2626" stroke="#fff" strokeWidth={1.5} />
        </svg>
    )
}
